/* eslint-disable react/prop-types */

import React from "react";
import { Box, makeStyles, Typography } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  selectedOptionLabel: {
    alignItems: "inherit",
    display: "inherit",
    overflow: "hidden",
  },
  isNewCompetitorOptionLabel: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "space-between",
    margin: "0 15px",
    paddingBottom: "7px",
    paddingTop: "7px",
    width: "100%",
  },
}));

const SelectorBoxComponent = ({ label, handleClick }) => {
  const classes = useStyles();
  return (
    <Box
      role="presentation"
      onClick={handleClick}
      className={classes.isNewCompetitorOptionLabel}
    >
      <Box className={classes.selectedOptionLabel}>
        <Typography variant="body2" noWrap>
          {label}
        </Typography>
      </Box>
    </Box>
  );
};

export default SelectorBoxComponent;
